import React, {useEffect, useRef, useState} from 'react'
import {useFormik} from 'formik'
import {Tooltip} from 'react-tooltip'
import {ModeleVehiculeEntre} from '../../../components/Models'
import {useAuth} from '../../modules/auth'
import {
  getGenreVehicule,
  getMarqueVehicule,
  getModeleVehicule,
  getSiteAll,
  getStatutVehicule,
  getTypeEnergie,
  getVehicules,
} from '../../../components/requests'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {Pagination} from '../../../components/Pagination'
import {useNavigate, useSearchParams} from 'react-router-dom'
import Select from 'react-select'
import {DemontageToShowPage} from './DemontageShowPage'
import {DemandeDemontageModal} from './DemandeDemontageModal'
import {TransfertStatutVehiculeModal} from './TransfertStatutVehiculeModal'
import {useLocation} from 'react-router'
import CustomOption from '../demande/Components/CustomOption'
import moment from 'moment/moment'

type LocationState = {
  marque: any | undefined | null
  modele: any | undefined | null
  vin: any | undefined | null
  immatriculation: any | undefined | null
  typePiece: any | undefined | null
  isVHT: boolean
  demandeId: number | null | undefined | string
  typePieceHn: string | null | undefined
  clientId: number
  isFromDemande: boolean
  clientDemandeImmat: number | undefined
  pieceSelected: any | undefined | null
  currentState: any | undefined | null
  pieceInstance: any | undefined | null
}

const DemontageListPage = () => {
  const [params] = useSearchParams()
  const location = useLocation()
  const locationState = location.state as LocationState | null
  const navigate = useNavigate()
  const [data, setData] = useState<Array<ModeleVehiculeEntre>>([])
  const [loading, setLoading] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>(params?.get('numeroVehicule') ?? '')
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()
  const [vehiculeToShow, setVehiculeToShow] = useState<ModeleVehiculeEntre>()
  const [marqueVehicule, setMarqueVehicule] = useState<any | undefined>([])
  const [modeleVehicule, setModeleVehicule] = useState<any | undefined>([])
  const [allMarqueVehicule, setAllMarqueVehicule] = useState<any | undefined>([])
  const [allModeleVehicule, setAllModeleVehicule] = useState<any | undefined>([])
  const [searchModel, setSearchModel] = useState<string>(locationState?.modele ?? '')
  const [searchMarque, setSearchMarque] = useState<string>(locationState?.marque ?? '')
  const [searchPhase, setSearchPhase] = useState<string>('')
  const [searchEnergie, setSearchEnergie] = useState<string>('')
  const [searchVin, setSearchVin] = useState<string>(locationState?.vin ?? '')
  const [searchNumero, setSearchNumero] = useState<string>('')
  const [searchPuissance, setSearchPuissance] = useState<string>('')
  const [valueMarque, setValueMarque] = useState<any>([])
  const [valueModele, setValueModele] = useState<any>([])
  const [spinner, setSpinner] = useState(false)
  const [vehiculeId, setVehiculeId] = useState<Number | undefined>(undefined)
  const [numero, setNumero] = useState<string | number | undefined>('')
  const [searchImmat, setSearchImmat] = useState<string | undefined>('')
  const [marqueModele, setMarqueModele] = useState<string | undefined>('')
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [openTransfertModal, setOpenTransfertModal] = useState<boolean>(false)
  const [menuInputValue, setMenuInputValue] = useState<string>('')
  const [sites, setSites] = useState<any>([])
  const [siteSelected, setSiteSelected] = useState<any>([])
  const [statut, setStatut] = useState<any>([])
  const [statutSelected, setStatutSelected] = useState<any>([])
  const [typeEnergieSelected, setTypeEnergieSelected] = useState<any>([])
  const [typesEnergie, setTypesEnergie] = useState<any>([])
  const [genreSelected, setGenreSelected] = useState<any>([])
  const [genres, setGenres] = useState<any>([])
  const [searchTypeMoteur, setSearchTypeMoteur] = useState<string>('')
  const [searchTypeBoite, setSearchTypeBoite] = useState<string>('')

  const handleNavigateToDemandePage = () => {
    if (locationState?.clientDemandeImmat && locationState?.currentState) {
      navigate(`/demandes/${locationState?.clientDemandeImmat}/enStock`, {
        state: locationState?.currentState,
      })
    }
  }

  // Récupération des marques de vehicules
  const getMarqueVehiculeData = () => {
    getMarqueVehicule()
      .then((marqueRequest) => {
        if (marqueRequest?.status === 200) {
          if (marqueRequest?.data !== undefined) {
            const transformedData = marqueRequest.data.map((item) => ({
              marque: item.id,
              value: item.nom,
              label: item.nom,
            }))
            setAllMarqueVehicule([...transformedData])
            setMarqueVehicule([...transformedData])

            // Verification des données depuis le locationState
            if (locationState?.marque !== undefined && locationState?.marque !== null) {
              const transformedData = marqueRequest.data
                .filter((m) => m.nom === locationState.marque)
                .map((item) => ({
                  marque: item.id,
                  value: item.nom,
                  label: item.nom,
                }))

              if (transformedData.length > 0) {
                setValueMarque([...transformedData])
              }
              setSearchMarque(locationState.marque)

              sessionStorage.setItem('marqueValue', JSON.stringify(transformedData))
              sessionStorage.setItem('marqueQuery', JSON.stringify(locationState.marque.toString()))
            }

            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
    const lastMarque = sessionStorage.getItem('marqueValue')
    if (lastMarque !== null) {
      setValueMarque(JSON.parse(lastMarque))
      setSearchMarque(JSON.parse(lastMarque))
    }
  }

  // Récupération des modeles de vehicules
  const getModeleVehiculeData = () => {
    getModeleVehicule()
      .then((modeleRequest) => {
        if (modeleRequest?.status === 200) {
          if (modeleRequest?.data !== undefined) {
            const transformedData = modeleRequest.data.map((item) => ({
              marque: item.idMarque,
              value: item.nom,
              label: item.nom,
            }))
            setAllModeleVehicule([...transformedData])
            setModeleVehicule([...transformedData])

            // Verification des données depuis le locationState
            if (locationState?.modele !== undefined && locationState?.modele !== null) {
              const transformedData = modeleRequest.data
                .filter((m) => m.nom === locationState.modele)
                .map((item) => ({
                  marque: item.idMarque,
                  value: item.nom,
                  label: item.nom,
                }))

              if (transformedData.length > 0) {
                setValueModele([...transformedData])
                setModeleVehicule([...transformedData])
              }
              sessionStorage.setItem('modeleValue', JSON.stringify(transformedData))

              if (transformedData?.some((item) => item?.label === locationState.modele)) {
                setSearchModel(locationState.modele)
                sessionStorage.setItem(
                  'modeleQuery',
                  JSON.stringify(locationState.modele.toString())
                )
              } else {
                setSearchModel('')
                sessionStorage.removeItem('modeleQuery')
              }
            }

            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
    const lastModele = sessionStorage.getItem('modeleValue')
    if (lastModele !== null) {
      setValueModele(JSON.parse(lastModele))
      setSearchModel(JSON.parse(lastModele))
    }
  }

  // Données formatées pour le filtre des sites
  const getSiteData = () => {
    getSiteAll()
      .then((siteRequest) => {
        const transformedData = siteRequest.map((item) => ({
          value: item.code,
          label: item.nom ?? item.code,
        }))
        setSites([...transformedData])
      })
      .catch((e) => {})
  }

  // Données formatées pour le filtre des types énergies
  const getTypeEnergieData = () => {
    getTypeEnergie()
      .then((energieRequest) => {
        const transformedData = energieRequest.map((item) => ({
          value: item?.typeEnergie,
          label: item?.typeEnergie,
        }))
        setTypesEnergie([...transformedData])
      })
      .catch((e) => {})
  }

  // Données formatées pour le filtre des types énergies
  const getStatutData = () => {
    getStatutVehicule()
      .then((statutRequest) => {
        const transformedData = statutRequest.map((item) => ({
          value: item?.statut,
          label: item?.statut,
        }))
        setStatut([...transformedData])
      })
      .catch((e) => {})
  }

  // Données formatées pour le filtre des genres
  const getGenreData = () => {
    getGenreVehicule()
      .then((genreRequest) => {
        const transformedData = genreRequest.map((item) => ({
          value: item.code,
          label: item.code,
        }))
        setGenres([...transformedData])
      })
      .catch((e) => {})
  }

  // Chargement du contenu des listes de marque et modèle pour les filtres
  useEffect(() => {
    getSiteData()
    getGenreData()
    getStatutData()
    getTypeEnergieData()
    getMarqueVehiculeData()
    getModeleVehiculeData()

    const lastPhase = sessionStorage.getItem('phaseQuery')
    const lastEnergie = sessionStorage.getItem('energieQuery')
    const lastPuissance = sessionStorage.getItem('puissanceQuery')
    const lastVin = sessionStorage.getItem('vinQuery')
    const lastNumero = sessionStorage.getItem('numeroQuery')
    const lastImmat = sessionStorage.getItem('immatQuery')

    if (lastPhase !== null) {
      setSearchPhase(JSON.parse(lastPhase))
      formik.setFieldValue('phase', JSON.parse(lastPhase))
    }
    if (lastEnergie !== null) {
      setSearchEnergie(JSON.parse(lastEnergie))
      formik.setFieldValue('energie', JSON.parse(lastEnergie))
    }
    if (lastPuissance !== null) {
      setSearchPuissance(JSON.parse(lastPuissance))
      formik.setFieldValue('puissance', JSON.parse(lastPuissance))
    }
    if (lastVin !== null) {
      setSearchVin(JSON.parse(lastVin))
      formik.setFieldValue('vin', JSON.parse(lastVin))
    }
    if (lastNumero !== null) {
      setSearchNumero(JSON.parse(lastNumero))
      formik.setFieldValue('numero', JSON.parse(lastNumero))
    }
    if (lastImmat !== null) {
      setSearchImmat(JSON.parse(lastImmat))
      formik.setFieldValue('immat', JSON.parse(lastImmat))
    }
  }, [])

  // filtrer les données de modèle apres selection de marque
  useEffect(() => {
    if (valueMarque.length > 0 && allModeleVehicule.length > 0) {
      const filteredModele = allModeleVehicule.filter((vehicule) =>
        valueMarque.some((item) => vehicule?.marque === item.marque)
      )
      setModeleVehicule(filteredModele)
    }
  }, [valueMarque, allMarqueVehicule, allModeleVehicule])

  // Synchronise UNE SEULE FOIS marque/modele depuis le locationState
  const didSyncLocationState = useRef(false)

  useEffect(() => {
    if (didSyncLocationState.current) return
    if (locationState?.marque !== undefined && locationState?.marque !== null) {
      setSearchMarque(locationState.marque)
    }
    if (locationState?.modele !== undefined && locationState?.modele !== null) {
      setSearchModel(locationState.modele)
    }
    didSyncLocationState.current = true
  }, [locationState])

  // Déclenche la recherche, réagit UNIQUEMENT aux states réels
  useEffect(() => {
    const hasCriteria =
      searchMarque !== '' ||
      searchModel !== '' ||
      searchPage !== '' ||
      searchPhase !== '' ||
      searchEnergie !== '' ||
      searchVin !== '' ||
      searchNumero !== '' ||
      searchImmat !== '' ||
      searchPuissance !== ''

    if (hasCriteria) {
      getVehiculesData()
    } else {
      setData([])
      setVehiculeToShow(undefined)
    }
  }, [
    currentPage,
    searchPage,
    searchMarque,
    searchModel,
    searchPhase,
    searchEnergie,
    searchVin,
    searchNumero,
    searchImmat,
    searchPuissance,
  ])

  const getVehiculesData = () => {
    setSpinner(true)
    setVehiculeToShow(undefined)
    const lastMarque = sessionStorage.getItem('marqueQuery') ?? ''
    const lastModele = sessionStorage.getItem('modeleQuery') ?? ''
    const searchMarqueValue = lastMarque ? JSON.parse(lastMarque) : searchMarque
    const searchModeleValue = lastModele ? JSON.parse(lastModele) : searchModel
    getVehicules(
      currentPage,
      searchPage,
      searchMarqueValue,
      searchModeleValue,
      true,
      searchPhase,
      searchEnergie,
      searchPuissance,
      searchVin,
      searchNumero,
      searchImmat,
      siteSelected?.value ?? '',
      typeEnergieSelected?.value ?? '',
      genreSelected?.value ?? '',
      searchTypeMoteur,
      searchTypeBoite,
      statutSelected?.value ?? ''
    ).then((vehiculesRequest) => {
      setNombreDePages(vehiculesRequest?.pages)
      setTotalPages(vehiculesRequest?.total)
      setCurrentPage(vehiculesRequest?.page)
      if (vehiculesRequest?.data !== undefined) {
        setData(vehiculesRequest?.data)
        if (vehiculesRequest?.data.length === 1 && params?.get('numeroVehicule')) {
          setVehiculeToShow(vehiculesRequest?.data[0])
        }
        setSpinner(false)
        setIsSearch(false)
      }
    })
  }

  const formik = useFormik({
    initialValues: {
      allSearch: params?.get('numeroVehicule') ?? '',
      marque: locationState?.marque ?? '',
      modele: locationState?.modele ?? '',
      phase: '',
      energie: '',
      puissance: '',
      vin: locationState?.vin ?? '',
      numero: '',
      immat: '',
      sites: '',
      typeMoteur: '',
      typeBoite: '',
    },
    onSubmit: (values, {setSubmitting}) => {
      setCurrentPage(1)

      const lastMarque = sessionStorage.getItem('marqueValue')
      const lastModele = sessionStorage.getItem('modeleValue')

      setSearchPage(values.allSearch)
      setSearchMarque(lastMarque ? JSON.parse(lastMarque) : values.marque)
      setSearchModel(lastModele ? JSON.parse(lastModele) : values.modele)
      setSearchPhase(values.phase)
      setSearchEnergie(values.energie)
      setSearchPuissance(values.puissance)
      setSearchVin(values.vin)
      setSearchNumero(values.numero)
      setSearchImmat(values.immat)
      setSearchTypeMoteur(values.typeMoteur)
      setSearchTypeBoite(values.typeBoite)

      sessionStorage.setItem('phaseQuery', JSON.stringify(values.phase))
      sessionStorage.setItem('energieQuery', JSON.stringify(values.energie))
      sessionStorage.setItem('puissanceQuery', JSON.stringify(values.puissance))
    },
  })

  const handleMarqueChange = (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueMarque([])
      setModeleVehicule(allModeleVehicule)
      formik.setFieldValue('marque', '')

      // suppression dans la session
      sessionStorage.removeItem('marqueValue')
      sessionStorage.removeItem('marqueQuery')
    } else {
      setValueMarque(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const marques = data
        ? data
            .map((marque) => marque.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('marque', marques.toString())

      // enregistrement dans la session
      sessionStorage.setItem('marqueValue', JSON.stringify(data))
      sessionStorage.setItem('marqueQuery', JSON.stringify(marques.toString()))
    }
    setIsSearch(true)
    formik.submitForm()
  }

  const handleModeleChange = (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueModele([])
      formik.setFieldValue('modele', '')

      // suppression dans la session
      sessionStorage.removeItem('modeleValue')
      sessionStorage.removeItem('modeleQuery')
    } else {
      setValueModele(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const modeles = data
        ? data
            .map((modele) => modele.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('modele', modeles.toString())

      // enregistrement dans la session
      sessionStorage.setItem('modeleValue', JSON.stringify(data))
      sessionStorage.setItem('modeleQuery', JSON.stringify(modeles.toString()))
    }
    setIsSearch(true)
    formik.submitForm()
  }

  // Style du select pour les filtres marque et modèle
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      backgroundColor: 'transparent',
    }),
  }

  const toggleShowModal = (val: boolean) => {
    setOpenModal(val)
  }

  const showEditModal = (
    vehiculeId: number | undefined,
    numero: string | undefined,
    marqueModele: string | undefined
  ) => {
    setOpenModal(true)
    setVehiculeId(vehiculeId)
    setNumero(numero)
    setMarqueModele(marqueModele)
  }

  const toggleShowTransfertModal = (val: boolean) => {
    setOpenTransfertModal(val)
  }

  const showTransfertModal = (
    vehiculeId: number | undefined,
    numero: string | undefined,
    marqueModele: string | undefined
  ) => {
    setOpenTransfertModal(true)
    setVehiculeId(vehiculeId)
    setNumero(numero)
    setMarqueModele(marqueModele)
  }

  const buttonDemandeTransfertVehicule = (vehicule) => {
    if (vehicule?.valide !== false && vehicule?.valide !== null) return null

    const demandeTransfertEnvoyee =
      vehicule?.demandeTransfertValidePar === null && vehicule?.valide === false

    return (
      <span
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        style={{cursor: `${demandeTransfertEnvoyee ? 'auto' : 'pointer'}`}}
        data-tooltip-id='tooltip'
        data-tooltip-content={
          demandeTransfertEnvoyee
            ? 'Demande de transfert envoyée'
            : 'Demander le transfert de statut'
        }
        data-tooltip-place='right'
        data-tooltip-offset={10}
      >
        <i
          className={`bi ${
            demandeTransfertEnvoyee ? 'bi-arrow-90deg-right' : 'bi-arrow-left-right'
          } fs-3`}
          onClick={() =>
            !demandeTransfertEnvoyee &&
            showTransfertModal(vehicule?.[0].id, vehicule?.[0].numero, vehicule?.marqueModel)
          }
        ></i>
      </span>
    )
  }

  const liensDetail = (data, vehicule) => {
    return (
      <p
        className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0 ms-2'
        style={{cursor: 'pointer'}}
        data-tooltip-id='tooltip'
        data-tooltip-content='Détail du véhicule'
        data-tooltip-place='left'
        onClick={() => {
          if (vehiculeToShow !== vehicule) {
            setVehiculeToShow(vehicule)
          } else {
            setVehiculeToShow(undefined)
          }
        }}
      >
        {data}
      </p>
    )
  }

  const resetSearch = () => {
    //vider les contenus de recherche
    setSearchPage('')
    setSearchMarque('')
    setSearchModel('')
    setSearchPhase('')
    setSearchEnergie('')
    setSearchPuissance('')
    setSearchVin('')
    setSearchNumero('')
    setSearchImmat('')
    setValueMarque([])
    setValueModele([])
    setSearchTypeBoite('')
    setSearchTypeMoteur('')
    setStatutSelected([])
    setTypeEnergieSelected([])
    setGenreSelected([])
    setSiteSelected([])

    //vider les valeurs dans le formik
    formik.setFieldValue('phase', '')
    formik.setFieldValue('vin', '')
    formik.setFieldValue('numero', '')
    formik.setFieldValue('immat', '')
    formik.setFieldValue('typeMoteur', '')
    formik.setFieldValue('typeBoite', '')
  }

  const filterOptions = (candidate: any, input: string) => {
    if (input) {
      const normalize = (text: string) => text.replace(/\s*-\s*/g, ' - ').toLowerCase() // remplacer le "-"  en " - "

      return normalize(candidate.label).includes(normalize(input))
    }
    return true
  }

  const handleSelecteChange = (data, type) => {
    if (type === 'site') {
      setSiteSelected(data)
    }
    if (type === 'statut') {
      setStatutSelected(data)
    }
    if (type === 'energie') {
      setTypeEnergieSelected(data)
    }
    if (type === 'genre') {
      setGenreSelected(data)
    }
  }
  const cell = {minWidth: 0} // empêche les selects (surtout multi) de déborder

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className={vehiculeToShow ? 'col-lg-8 col-md-6' : 'col-lg-12 col-sm-12'}>
          <div className={`card card-xxl-stretch h-100`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start d-flex'>
                {!locationState?.isFromDemande ? (
                  <span className='card-label fw-bold fs-3 mb-1'>Véhicules</span>
                ) : (
                  <>
                    <span className='card-label fw-bold fs-3 mb-1'>Recherche Parc Véhicules</span>
                    {(locationState?.marque || locationState?.modele) && (
                      <span className='card-label fw-bold fs-3 mb-1 text-muted'>
                        {' '}
                        — {`${locationState?.marque} — ${locationState?.modele}`}
                      </span>
                    )}
                    {locationState?.vin && (
                      <span className='card-label fw-bold fs-3 mb-1 text-muted'>
                        {' '}
                        — {locationState?.vin}
                      </span>
                    )}
                    {locationState?.immatriculation && (
                      <span className='card-label fw-bold fs-3 mb-1 text-muted'>
                        {' '}
                        — {locationState?.immatriculation}
                      </span>
                    )}
                    <span className='card-label fw-bold fs-3 mb-1 text-muted'>
                      {' '}
                      — {locationState?.typePiece?.nom ?? locationState?.typePieceHn}
                    </span>
                  </>
                )}
              </h3>
              {locationState?.isFromDemande && (
                <div>
                  <button
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Revenir à la demande'
                    data-tooltip-place='right'
                    className='btn btn-light'
                    onClick={handleNavigateToDemandePage}
                  >
                    <i className='ki-duotone ki-arrow-left fs-3'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    Retour à la demande
                  </button>
                </div>
              )}
            </div>
            {shouldDisplayFonctionnalite(currentUser, 'VOIR VEHICULE') && (
              <>
                <div className='d-flex mx-9 align-items-center justify-content-between'>
                  {locationState?.isVHT ? (
                    <div className='d-flex gap-2 align-items-center'>
                      <i className='bi bi-info-square text-warning'></i>
                      <span className={'text-warning'}>Véhicule hors type</span>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div>
                    <button
                      className='cursor-pointer btn btn-success btn-sm'
                      onClick={() => resetSearch()}
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Réinitialiser le filtre'
                      data-tooltip-place='top'
                    >
                      <i className='bi bi-x' style={{fontSize: '16px'}}></i>
                      Réinitialiser
                    </button>
                  </div>
                </div>
                {/* debut champs recherche */}
                <form
                    className='card-header border-0 pt-5 pb-5 d-block'
                    onSubmit={formik.handleSubmit}
                >
                  <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
                        gap: '12px 16px',
                        alignItems: 'start',
                      }}
                  >
                    <div style={cell}>
                      <label>Statut</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={statut}
                          value={statutSelected}
                          placeholder='Statut'
                          onChange={(data) => handleSelecteChange(data, 'statut')}
                      />
                    </div>

                    <div style={cell}>
                      <label>Site</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={sites}
                          value={siteSelected}
                          placeholder='Site'
                          onChange={(data) => handleSelecteChange(data, 'site')}
                      />
                    </div>

                    <div style={cell}>
                      <label>Type énergie</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={typesEnergie}
                          value={typeEnergieSelected}
                          placeholder='Type énergie'
                          onChange={(data) => handleSelecteChange(data, 'energie')}
                      />
                    </div>

                    <div style={cell}>
                      <label>Genre</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={genres}
                          value={genreSelected}
                          placeholder='Genre'
                          onChange={(data) => handleSelecteChange(data, 'genre')}
                      />
                    </div>

                    <div style={cell}>
                      <label>Marque (max 5)</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={marqueVehicule}
                          value={valueMarque}
                          placeholder='Marque'
                          isDisabled={marqueVehicule.length === 0}
                          isLoading={marqueVehicule.length === 0}
                          isClearable
                          isMulti
                          onChange={(data) => handleMarqueChange(data)}
                          isOptionDisabled={() => valueMarque.length >= 5}
                      />
                    </div>

                    <div style={cell}>
                      <label>Modèle</label>
                      <Select
                          styles={customStyles}
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={modeleVehicule}
                          value={valueModele}
                          placeholder='Modele'
                          isDisabled={modeleVehicule.length === 0}
                          isLoading={modeleVehicule.length === 0}
                          isClearable
                          isMulti
                          onChange={(data) => handleModeleChange(data)}
                          components={{Option: CustomOption}}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          blurInputOnSelect={false}
                          filterOption={filterOptions}
                          inputValue={menuInputValue}
                          onInputChange={(text, action) => {
                            if (action.action === 'input-change') {
                              setMenuInputValue(text)
                            } else if (action.action === 'menu-close' || action.action === 'input-blur') {
                              setMenuInputValue('')
                            }
                          }}
                      />
                    </div>

                    <div style={cell}>
                      <label>Phase</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('phase')} name='phase' placeholder='Phase' />
                    </div>

                    <div style={cell}>
                      <label htmlFor='vin'>VIN</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('vin')} name='vin' placeholder='VIN' id='vin' />
                    </div>

                    <div style={cell}>
                      <label>NE</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('numero')} name='numero' placeholder='NE' />
                    </div>

                    <div style={cell}>
                      <label>Immatriculation</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('immat')} name='immat' placeholder='Immatriculation' />
                    </div>

                    <div style={cell}>
                      <label>Type moteur</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('typeMoteur')} name='typeMoteur' placeholder='Type moteur' />
                    </div>

                    <div style={cell}>
                      <label>Type boite (code)</label>
                      <input type='text' className='form-control' {...formik.getFieldProps('typeBoite')} name='typeBoite' placeholder='Type boite' />
                    </div>

                    {/* Bouton : toujours dans la dernière colonne, aligné avec les champs */}
                    <div
                        style={{gridColumn: '-2 / -1', alignSelf: 'end', minWidth: 0}}
                        className='d-flex justify-content-end'
                    >
                      <button
                          className='btn btn-primary d-flex align-items-center justify-content-center gap-2 w-100'
                          type='submit'
                          onClick={() => setIsSearch(true)}
                      >
                        <i className='bi bi-search'></i>
                        Rechercher
                      </button>
                    </div>
                  </div>
                </form>

                {/* fin champs recherche */}
                {/* end::Header */}
                <>
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            {/*<th className='min-w-120px'>Immatriculation</th>*/}
                            <th className='min-w-120px'>Statut</th>
                            <th className='min-w-120px'>Site</th>
                            <th className='min-w-120px'>Emplacement</th>
                            <th className='min-w-140px'>NE</th>
                            <th className='min-w-140px'>Destination</th>
                            {/*<th className='min-w-140px'>Type</th>*/}
                            <th className='min-w-140px'>Type énergie</th>
                            <th className='min-w-140px'>Genre</th>
                            <th className='min-w-140px'>Marque</th>
                            <th className='min-w-140px'>Modèle</th>
                            <th className='min-w-50px'>Phase</th>
                            <th className='min-w-50px'>Année</th>
                            <th className='min-w-50px'>Kilométrage</th>
                            <th className='min-w-140px'>Couleur</th>
                            <th className='min-w-140px'>Date d'épollution</th>
                            <th className='min-w-140px'>Cylindrée(em cm²)</th>
                            <th className='min-w-140px'>Type moteur</th>
                            <th className='min-w-140px'>Type boite</th>
                            <th className='min-w-140px'>Type sinistre</th>
                            <th className='min-w-140px'>Date à disposition</th>
                            <th className='min-w-140px'>Prix d'achat</th>
                            <th className='min-w-200px'>Prix de vente VA</th>
                            <th className='min-w-140px'>Etat</th>
                            {/*<th className='min-w-140px'>Code Moteur</th>*/}
                            {/*<th className='min-w-140px'>Type Batterie</th>*/}
                            {/* code commenter pour le moment */}
                            {/*{!vehiculeToShow && <th className='min-w-140px'>Genre</th>}*/}
                            {/*<th className='min-w-140px'>Energie</th>*/}
                            {/*{!vehiculeToShow && <th className='min-w-140px'>Puissance</th>}*/}
                            <th className='min-w-100px text-center'>Voir les demandes</th>
                            <th className='min-w-40px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {spinner ? (
                            <tr>
                              <td colSpan={24} className='p-4 text-center h-500px'>
                                <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                              </td>
                            </tr>
                          ) : data.length ? (
                            data.map((vehicule) => {
                              return (
                                <>
                                  <tr
                                    key={vehicule?.[0].id}
                                    style={{
                                      backgroundColor:
                                        vehicule[0] == vehiculeToShow ? '#9AC331' : '',
                                    }}
                                  >
                                    {/*<td>*/}
                                    {/*  <div className='d-flex align-items-center'>*/}
                                    {/*    <div className='d-flex justify-content-start flex-column'>*/}
                                    {/*      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0 ms-2'>*/}
                                    {/*        {vehicule?.[0].immatriculation}*/}
                                    {/*      </p>*/}
                                    {/*    </div>*/}
                                    {/*  </div>*/}
                                    {/*</td>*/}
                                    <td>
                                      <div className='d-flex align-items-center'>
                                        <div className='d-flex justify-content-start flex-column'>
                                          {liensDetail(vehicule?.[0]?.statut, vehicule?.[0])}
                                        </div>
                                      </div>
                                    </td>
                                    <td>{liensDetail(vehicule?.[0]?.site?.code, vehicule?.[0])}</td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {liensDetail(vehicule?.[0]?.emplacement, vehicule?.[0])}
                                      </p>
                                    </td>
                                    <td>{liensDetail(vehicule?.[0].numero, vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0].destination, vehicule?.[0])}</td>
                                    {/*<td>*/}
                                    {/*  {liensDetail(*/}
                                    {/*    vehicule?.[0].vehicule?.modele?.type?.code,*/}
                                    {/*    vehicule?.[0]*/}
                                    {/*  )}*/}
                                    {/*</td>*/}
                                    <td>{liensDetail(vehicule?.[0].energie, vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.genreCode, vehicule?.[0])}</td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0].vehicule?.modele?.marque?.nom,
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0].vehicule?.modele?.nom,
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0].vehicule?.modele?.phase
                                          ? 'phase ' + vehicule?.[0].vehicule?.modele?.phase
                                          : '',
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>{liensDetail(vehicule?.[0].annee ?? '', vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0].km + ' km', vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0].couleur, vehicule?.[0])}</td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0]?.dateDepollution
                                          ? moment(vehicule?.[0]?.dateDepollution).format(
                                              'DD/MM/YYYY'
                                            )
                                          : '',
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0].vehicule?.modele?.cylindre,
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>{liensDetail(vehicule?.[0].typeMoteur, vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0]?.typeBoite, vehicule?.[0])}</td>
                                    <td>
                                      {liensDetail(vehicule?.[0]?.typeSinistre, vehicule?.[0])}
                                    </td>
                                    <td>
                                      {liensDetail(
                                        vehicule?.[0]?.dateDisposition
                                          ? moment(vehicule?.[0]?.dateDisposition).format(
                                              'DD/MM/YYYY'
                                            )
                                          : '',
                                        vehicule?.[0]
                                      )}
                                    </td>
                                    <td>{liensDetail(vehicule?.[0].prixAchat, vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0].prixVente, vehicule?.[0])}</td>
                                    <td>{liensDetail(vehicule?.[0].etat, vehicule?.[0])}</td>

                                    {/*<td>*/}
                                    {/*  {liensDetail(*/}
                                    {/*    vehicule?.[0].vehicule?.modele?.codeMoteur,*/}
                                    {/*    vehicule?.[0]*/}
                                    {/*  )}*/}
                                    {/*</td>*/}
                                    {/*<td>*/}
                                    {/*  {liensDetail(*/}
                                    {/*    vehicule?.[0].boiteAuto ? 'Automatique' : 'Manuel',*/}
                                    {/*    vehicule?.[0]*/}
                                    {/*  )}*/}
                                    {/*</td>*/}
                                    {/*<td>*/}
                                    {/*  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>*/}
                                    {/*    {}*/}
                                    {/*  </p>*/}
                                    {/*</td>*/}

                                    {/* code commenter pour le moment */}
                                    {/*{!vehiculeToShow && (*/}
                                    {/*  <td>*/}
                                    {/*    <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>*/}
                                    {/*      {vehicule?.[0].vehicule?.modele?.type?.code}*/}
                                    {/*    </p>*/}
                                    {/*  </td>*/}
                                    {/*)}*/}
                                    {/*<td>*/}
                                    {/*  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>*/}
                                    {/*    {vehicule?.[0].energie}*/}
                                    {/*  </p>*/}
                                    {/*</td>*/}
                                    {/*{!vehiculeToShow && (*/}
                                    {/*  <td>*/}
                                    {/*    <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>*/}
                                    {/*      {vehicule?.[0].vehicule?.modele?.puissance}*/}
                                    {/*    </p>*/}
                                    {/*  </td>*/}
                                    {/*)}*/}

                                    <td className='text-center'>
                                      {vehicule?.demandeDemontageId && (
                                        <span
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                          style={{cursor: 'pointer'}}
                                          data-tooltip-id='tooltip'
                                          data-tooltip-content='Voir les demandes'
                                          data-tooltip-place='right'
                                        >
                                          <a
                                            href={`/demande-demontage/liste?vehicule=${vehicule?.[0]?.numero}`}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                          >
                                            <i className='bi bi-search fs-3'></i>
                                          </a>
                                        </span>
                                      )}
                                    </td>

                                    <td style={{verticalAlign: 'middle'}}>
                                      <div
                                        className='d-flex justify-content-end align-items-center flex-shrink-0 gap-2'
                                        style={{height: '100%'}}
                                      >
                                        {shouldDisplayFonctionnalite(
                                          currentUser,
                                          'CREER DEMANDE DEMONTAGE'
                                        ) && (
                                          /*{(vehicule?.statut === "Mise à dispo") && (*/
                                          <span
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                            style={{cursor: 'pointer'}}
                                            data-tooltip-id='tooltip'
                                            data-tooltip-content='Créer une demande de démontage'
                                            data-tooltip-place='right'
                                          >
                                            <i
                                              className='bi bi-plus-circle-fill fs-3'
                                              onClick={() =>
                                                showEditModal(
                                                  vehicule?.[0].id,
                                                  vehicule?.[0].numero,
                                                  vehicule?.marqueModel
                                                )
                                              }
                                            ></i>
                                          </span>
                                          /*)}*/
                                        )}
                                        {shouldDisplayFonctionnalite(
                                          currentUser,
                                          'DEMANDER TRANSFERT DEMONTAGE'
                                        ) && buttonDemandeTransfertVehicule(vehicule)}
                                        {/*<span*/}
                                        {/*  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'*/}
                                        {/*  style={{cursor: 'pointer'}}*/}
                                        {/*  data-tooltip-id='tooltip'*/}
                                        {/*  data-tooltip-content='Détail du véhicule'*/}
                                        {/*  data-tooltip-place='left'*/}
                                        {/*>*/}
                                        {/*  <i*/}
                                        {/*    className={`bi bi-eye fs-2 fw-bold text-hover-primary ${*/}
                                        {/*      vehiculeToShow === vehicule?.[0] && 'text-primary'*/}
                                        {/*    }`}*/}
                                        {/*    onClick={() => {*/}
                                        {/*      if (vehiculeToShow !== vehicule?.[0]) {*/}
                                        {/*        setVehiculeToShow(vehicule?.[0])*/}
                                        {/*      } else {*/}
                                        {/*        setVehiculeToShow(undefined)*/}
                                        {/*      }*/}
                                        {/*    }}*/}
                                        {/*  ></i>*/}
                                        {/*</span>*/}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={24} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    {data.length !== 0 ? (
                      <Pagination
                        totalPages={totalPages}
                        nombreDePages={nombreDePages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        locationState={locationState}
                      />
                    ) : (
                      ''
                    )}
                    {/* end::pagination*/}
                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip' />
                    {/*<ToastContainer position='bottom-right' autoClose={3000} />*/}
                  </div>
                </>
              </>
            )}
          </div>
        </div>
        <div className='col-lg-4 col-md-6'>
          {vehiculeToShow && (
            <DemontageToShowPage
              vehicule={vehiculeToShow}
              setVehiculeToShow={setVehiculeToShow}
              vehicules={data}
            />
          )}
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
      {openModal && (
        <DemandeDemontageModal
          show={openModal}
          numeroVehicule={numero}
          vehiculeId={vehiculeId}
          showModal={toggleShowModal}
          isEdition={false}
          demandeDemontageId={undefined}
          setData={setData}
          marqueModele={marqueModele}
          typePiece={locationState?.typePiece}
          isRedirection={true}
          demandeId={locationState?.demandeId}
          typePieceHn={locationState?.typePieceHn}
          pieceInstance={locationState?.pieceInstance}
        />
      )}

      {openTransfertModal && (
        <TransfertStatutVehiculeModal
          show={openTransfertModal}
          numeroVehicule={numero}
          vehiculeId={vehiculeId}
          data={data}
          setData={setData}
          showModal={toggleShowTransfertModal}
          marqueModele={marqueModele}
        />
      )}
    </>
  )
}

export {DemontageListPage}
